import { render } from "./PostAds.vue?vue&type=template&id=5d89bb28"
import script from "./PostAds.vue?vue&type=script&lang=js"
export * from "./PostAds.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__